import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationPropagated = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .18
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 10.2441,
			width: 12.3358,
			height: 3.52451,
			rx: 1.76226,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.8248,
			y: 11.8992,
			width: 8.35319,
			height: 3.95735,
			rx: 1.97868,
			transform: "rotate(135 19.8248 11.8992)",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.8248,
			y: 11.8992,
			width: 4.1766,
			height: 7.9147,
			rx: 2,
			transform: "rotate(135 19.8248 11.8992)",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotationPropagated);
export { ForwardRef as ReactComponent };
